import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';

function Footer() {
  const [contactData, setContactData] = useState(null);
// console.log(contactData);
const [visitorCount, setVisitorCount] = useState(null);
const [facebook, setFacebook] = useState(null);
  const [youtube, setYoutube] = useState(null);
  const [instagram, setInstagram] = useState(null);

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        "https://dharshancrackers.com/customer_api/home.php"
      );

      const { body } = response.data;
      
      setYoutube(body?.youtube_channel_url) ;
      setFacebook(body?.facebook_url) ;
      setInstagram(body?.instagram_url) ;
     

    } catch (error) {
      console.error("There was an error fetching the data!", error);
    } 
  };

  fetchData();
}, []);
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(" https://dharshancrackers.com/customer_api/content.php");
        const { body } = response.data;
        setContactData(body.contact);
        setVisitorCount(body.visitor_count)
      } catch (error) {
        console.error("Error fetching the contact data", error);
      }
    };

    fetchContactData();
  }, []);

  // Fallback content if data is not loaded
  if (!contactData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
       
      <footer id="footer" className="footer dark-background">
        
        <div className="container1">
          <div className="row gy-3">
            <div className="col-lg-4 col-md-6 d-flex">
              <i className="bi bi-geo-alt icon"></i>
              <div className="address">
                <h4>Address</h4>
                <p className='contactfooter'>{contactData.address}</p>&nbsp;
                 <h3>Visitors Count: {visitorCount.visitor_count}</h3>
              </div>
             

            </div>

            <div className="col-lg-4 col-md-6 d-flex">
              <i className="bi bi-telephone icon"></i>
              <div>
                <h4>Contact</h4>
                <p className='contactfooter'>
                  <strong >Phone:</strong> <span>{contactData.phonenumber}</span><br/><br/>
                  <strong>Email:</strong> <span>{contactData.email}</span><br/><br/>
                  <strong>WhatsApp:</strong> <span>{contactData.whatsapp_number}</span>
                </p>
          <div className="social-links d-flex align-items-center  gap-2">
              <h4 className="mb-0">Follow Us :</h4>
              <Link to={facebook}  target="_blank" className="facebook"><i className="bi bi-facebook"></i></Link>
              <Link to={instagram}  target="_blank" className="instagram"><i className="bi bi-instagram"></i></Link>
              <Link to={youtube}  target="_blank" className="linkedin"><i className="bi bi-youtube"></i></Link>
            </div>

              </div>
            </div>

      

            <div className="col-lg-4 col-md-6 d-flex">
              <i className="bi bi-telephone icon"></i>
              <div>
                <h4>Quick Links</h4>
                <p className='footer-quicklink'>
                <Link to= "/shippingpolicy"> <strong style={{ color: "#024102" }}><i className="bi bi-arrow-right"></i></strong> <span className='footlinks'>Shipping & Delivery</span><br/><br/></Link>
                  <Link to= "/terms">  <strong style={{ color: "#024102" }}><i className="bi bi-arrow-right"></i></strong> <span className='footlinks'>Terms & Conditions</span><br/><br/> </Link>
                 <Link to= "/privacy"> <strong style={{ color: "#024102" }}><i className="bi bi-arrow-right"></i></strong> <span className='footlinks'>Privacy Policy</span> </Link>
                </p>
              </div>
            </div>

            {/* <div className="col-lg-2 col-md-6">
              
            </div> */}
          </div>
        </div>
        
        <div className="rules">
          <p className='rules1'>
            Please Note: The honorable Supreme Court of India has banned sales of firecrackers from 2018. We obey the order and we don't permit online
            purchase of crackers. For your convenience, we show our products on the website. We request you to add your products to the Quick
            Purchase and submit the required crackers through the enquiry button. We will contact you within 24 hrs and confirm the order
            through WhatsApp or phone call. Please add and submit your enquiries and enjoy your Diwali with Dharshan Crackers.
          </p>
          
        </div>
       
      </footer>
      
     
      <div className="container12 text-center mt-4">
         
          <p><b><span>Copyright © {new Date().getFullYear()}</span> <strong className="px-1 sitename">Dharshan Crackers .</strong> <span>All Rights Reserved.</span> Developed by <Link to="https://aatheshsoft.com/" style={{ color: " rgb(242 148 27)" }}> Aathesh Soft Solutions</Link></b></p>
        </div>
    </div>
  );
}

export default Footer;
